import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { clearPendingCheckoutReference, readCheckoutDraft } from "../utils/checkoutStorage";

const CheckoutCancel = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !user) {
      return;
    }

    clearPendingCheckoutReference();

    navigate("/checkout", {
      replace: true,
      state: {
        ...(readCheckoutDraft()?.checkoutState || {}),
        message: "Payment was not completed. Your checkout details have been restored.",
      },
    });
  }, [loading, navigate, user]);

  if (loading) {
    return (
      <div className="min-h-screen px-6 py-24">
        <div className="mx-auto max-w-3xl rounded-[2rem] bg-white p-10 text-center shadow-lg shadow-black/5">
          <p className="text-lg text-slate-700">Restoring checkout...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: { pathname: "/checkout-cancel", search: window.location.search } }}
      />
    );
  }

  return null;
};

export default CheckoutCancel;
